import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { StartCaseModule } from '@portal-core/general/pipes/start-case/start-case.module';
import { StatusIncidentDialogComponent } from './status-incident-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    StartCaseModule
  ],
  declarations: [
    StatusIncidentDialogComponent
  ],
  exports: [
    StatusIncidentDialogComponent
  ],
  providers: [DatePipe]
})
export class StatusIncidentDialogModule { }
